<hlm-dialog-header>
  <h3 hlmDialogTitle>Supprimer {{ nom }}</h3>
</hlm-dialog-header>

<div class="py-6">
  <div class="mx-8 flex flex-col gap-6">
    <span class="gap-xs text-content-secondary flex items-center">
      <ng-icon name="lucideLink2" hlm size="sm" />
      {{ childrenText }}
    </span>
    <p>
      Êtes-vous sûr de vouloir supprimer <span class="font-bold">{{ nom }}</span> ? Si vous validez la suppression, les
      sous-catégories de <span class="font-bold">{{ nom }}</span> seront également supprimées.
    </p>
    <app-alerte
      [message]="'Vous ne pourrez pas récupérer ' + typeElement + '.'"
      title="Attention, cette action est irréversible."
      type="negative"
    />
    <div class="flex flex-col gap-1">
      <span>Écrivez <span class="font-bold">SUPPRIMER</span> pour confirmer la suppression.</span>
      <input [(ngModel)]="supprimer" hlmInput type="text" placeholder='Écrivez "SUPPRIMER" en majuscule.' />
    </div>
  </div>
</div>

<hlm-dialog-footer>
  <div class="flex w-full flex-col">
    <hlm-separator />
    <button
      class="m-4"
      [disabled]="supprimer() !== CONFIRMATION_SUPPRESSION_TEXTE"
      (click)="close()"
      hlmBtn
      variant="destructive"
    >
      Je comprends les conséquences, supprimer {{ nom }}
    </button>
  </div>
</hlm-dialog-footer>
